/* eslint-disable indent */
import { Modal, Form, Input, InputNumber, Switch, Button } from "antd";
import axios from "axios";
import { useState } from "react";

import { createSlug } from "../../../../../utils/helper.jsx";
import { showErrorNotification } from "../../../../../utils/notification";
import { MODAL_CONFIG_MODES } from "../../BlogsDashboard";

const FolderModal = ({ config, onClose, ROOT_URL, BASE_URL }) => {
  const [form] = Form.useForm();
  const [slugManuallyEdited, setSlugManuallyEdited] = useState(false);
  const isEdit = config.mode === MODAL_CONFIG_MODES.EDIT_FOLDER;

  let initialValues = { isExpandedByDefault: true };
  initialValues = isEdit
    ? { ...initialValues, ...config.parentNode }
    : { ...initialValues, isFolder: true };

  // Called whenever form values change
  const handleValuesChange = (changedValues, _allValues) => {
    if ("title" in changedValues && !slugManuallyEdited) {
      const title = changedValues.title || "";
      const autoSlug = createSlug(title);

      form.setFieldsValue({ slug: autoSlug });
    }
  };

  const handleSubmit = async (formData) => {
    try {
      await axios.post(`${ROOT_URL}/${BASE_URL}/tree-node/${isEdit ? "update" : "create"}`, {
        ...formData,
        isFolder: true,
        isExpandedByDefault: formData?.isExpandedByDefault ?? true,
        parentActiveUniqueUrlIdentifier: config.parentNode?.activeUniqueUrlIdentifier || null
      });
      onClose(true);
    } catch (err) {
      showErrorNotification(err);
    }
  };

  return (
    <Modal
      title={
        isEdit
          ? `Edit Folder: ${config?.parentNode?.title || "Root"}`
          : `Add New Folder in "${config?.parentNode?.title || "Root"}"`
      }
      open={config.open}
      onCancel={() => onClose(false)}
      footer={null}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        initialValues={initialValues}
        onValuesChange={handleValuesChange}
      >
        <Form.Item
          name="title"
          label="Folder Title"
          rules={[{ required: true, message: "Please enter a folder title" }]}
        >
          <Input placeholder="Dynamic Programming" />
        </Form.Item>

        <Form.Item name="slug" label="Slug">
          <Input placeholder="dynamic-programming" onChange={() => setSlugManuallyEdited(true)} />
        </Form.Item>

        <Form.Item
          name="displayOrderUnderParent"
          label="Display Order"
          tooltip="Controls order within the same parent"
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="isExpandedByDefault"
          label="Expanded By Default"
          valuePropName="checked"
          tooltip="If off, this folder stays collapsed by default on frontend"
        >
          <Switch checkedChildren="Yes" unCheckedChildren="No" />
        </Form.Item>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px"
          }}
        >
          <Button onClick={() => onClose(false)} style={{ marginRight: "10px" }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            {isEdit ? "Update Folder" : "Create Folder"}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default FolderModal;
